import React from "react";
import Lottie from "react-lottie";
import styled from "styled-components";
import animationData from "./SpinningAnimation/spinning-animation.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  setSpeed: 0.1,
};

export function SpinningAnimation() {
  return (
    <Centerer>
      <Lottie options={defaultOptions} />
    </Centerer>
  );
}

const Centerer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.color.buttonPrimary};
  border-radius: ${(props) => props.theme.layout.borderRadius.md};
`;
